export default function (str) {
  return typeof str === 'string';
}